// Canonical URL utility
const CANONICAL_BASE = 'https://www.officinedelcuore.it';

export const getCanonicalUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  // Return canonical URL
  return cleanPath ? `${CANONICAL_BASE}/${cleanPath}` : CANONICAL_BASE;
};

export default getCanonicalUrl;
